<template >
  <div>
    <div class="app-modal__box" :class="mode ? '' : 'performance__night'">
      <div class="app-modal__in">
        <div class="app-modal__header d-flex f-between p-5 m-title-modal">
          <p class="large--title m-0" :class="mode ? 'text__day2' : 'text__night2'">{{
              $t("message.new_m", {
                  m: $t("message.vacancy"),
              })
          }}</p>
          <crm-store-update-close
            :permission="$options.name"
            :button_type="'store'"
            :loading="loadingButton"
            @c-submit="submit(false)"
            @c-close="close()"
          ></crm-store-update-close>
        </div>
      </div>
      <!-- app-modal__header end -->

      <div class="app-modal__body p-5 pb-0">
        <div class="timeline-items__right rounded-sm w-100 p-4" :class="mode ? 'table__myday' : 'table__mynight'">
          <el-form ref="form" status-icon :model="form" :rules="rules">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2" >
                    {{ $t("message.name") }}
                  </span>
                  <el-form-item prop="name">
                    <crm-input
                    :class="mode ? 'input__day' : 'input__night'"
                      :inputValue="form.name"
                      :placeholder="$t('message.name')"
                      :size="'medium'"
                      v-model="form.name"
                    ></crm-input>
                  </el-form-item>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2" >
                    {{ $t("message.gender") }}
                  </span>
                  <el-form-item prop="gender_ids">
                    <select-gender
                      :size="'medium'"
                      :multiple="true"
                      :placeholder="columns.gender_ids.title"
                      :id="form.gender_ids"
                      v-model="form.gender_ids"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-gender>
                  </el-form-item>
                </div>
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2" >
                    {{ $t("message.company") }}
                  </span>
                  <el-form-item prop="company_id">
                    <select-company
                      :size="'medium'"
                      :id="form.company_id"
                      :placeholder="columns.company_id.title"
                      v-model="form.company_id"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-company>
                  </el-form-item>
                </div>
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.branch") }}
                  </span>
                  <el-form-item prop="branch_id">
                    <select-branch
                      :size="'medium'"
                      :id="form.branch_id"
                      :placeholder="columns.branch_id.title"
                      v-model="form.branch_id"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-branch>
                  </el-form-item>
                </div>
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.department") }}
                  </span>
                  <el-form-item prop="department_ids">
                    <select-department
                      :branch_id="form.branch_id"
                      :size="'medium'"
                      :multiple="true"
                      :placeholder="columns.department_ids.title"
                      :id="form.department_ids"
                      v-model="form.department_ids"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-department>
                  </el-form-item>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.requirements") }}
                  </span>
                  <el-form-item prop="requirement_ids">
                    <select-requirement
                      :id="form.requirement_ids"
                      :size="'medium'"
                      :placeholder="columns.requirement_ids.title"
                      v-model="form.requirement_ids"
                      :multiple="true"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-requirement>
                  </el-form-item>
                </div>

                <div class="app-form__group mb-0">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.age") }}
                  </span>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item prop="min_age">
                        <el-input-number
                        :class="mode ? 'input__day' : 'input__night'"
                          v-model="form.min_age"
                          controls-position="right"
                          :min="18"
                          :max="60"
                          size="medium"
                          class="w-100"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="max_age">
                        <el-input-number
                        :class="mode ? 'input__day' : 'input__night'"
                          v-model="form.max_age"
                          controls-position="right"
                          :min="18"
                          :max="70"
                          size="medium"
                          class="w-100"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.priority") }}
                  </span>
                  <el-form-item prop="priority_id">
                    <select-priority
                      :size="'medium'"
                      :placeholder="columns.priority_id.title"
                      :id="form.priority_id"
                      v-model="form.priority_id"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-priority>
                  </el-form-item>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.position") }}
                  </span>
                  <el-form-item prop="position_id">
                    <select-position
                      :size="'medium'"
                      :id="form.position_id"
                      :placeholder="columns.position_id.title"
                      v-model="form.position_id"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-position>
                  </el-form-item>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.graphic") }}
                  </span>
                  <el-form-item prop="graphic_ids">
                    <select-graphic
                      :size="'medium'"
                      :multiple="true"
                      :id="form.graphic_ids"
                      v-model="form.graphic_ids"
                      :class="mode ? 'input__day' : 'input__night'"
                    ></select-graphic>
                  </el-form-item>
                </div>
              </el-col>
              <!-- end col -->
              <el-col :span="12">
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.limit") }}
                  </span>
                  <el-form-item prop="limit">
                    <el-input-number
                    :class="mode ? 'input__day' : 'input__night'"
                      v-model="form.limit"
                      controls-position="right"
                      :min="1"
                      :max="100"
                      size="medium"
                      class="w-100"
                    >
                    </el-input-number>
                  </el-form-item>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.employmentType") }}
                  </span>
                  <el-form-item prop="employment_type_id">
                    <select-employmentType
                      :size="'medium'"
                      :placeholder="columns.employment_type_id.title"
                      :id="form.employment_type_id"
                      v-model="form.employment_type_id"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-employmentType>
                  </el-form-item>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.language") }}
                  </span>
                  <el-form-item prop="language_ids">
                    <select-language
                      :size="'medium'"
                      :multiple="true"
                      :placeholder="columns.language_ids.title"
                      :id="form.language_ids"
                      v-model="form.language_ids"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-language>
                  </el-form-item>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.skill") }}
                  </span>
                  <el-form-item prop="skill_ids">
                    <select-skill
                      :size="'medium'"
                      :multiple="true"
                      :placeholder="columns.skill_ids.title"
                      :id="form.skill_ids"
                      v-model="form.skill_ids"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-skill>
                  </el-form-item>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.salary_currency") }}
                  </span>
                  <el-form-item prop="currency_ids">
                    <select-currency
                      :size="'medium'"
                      :multiple="true"
                      :placeholder="columns.currency_ids.title"
                      :id="form.currency_ids"
                      v-model="form.currency_ids"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-currency>
                  </el-form-item>
                </div>

                <div class="app-form__group">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2"> {{$t('message.salary')}} </span>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item prop="min_wage">
                        <el-input
                        :class="mode ? 'input__day' : 'input__night'"  
                        :placeholder="$t('message.min')"
                          v-model="form.min_wage"
                          type="number"
                          size="medium"
                          filterable
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="max_wage">
                        <el-input
                        :class="mode ? 'input__day' : 'input__night'"  
                        :placeholder="$t('message.max')"
                          v-model="form.max_wage"
                          type="number"
                          size="medium"
                          filterable
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.province") }}
                  </span>
                  <el-form-item prop="region_id">
                    <select-region
                      :size="'medium'"
                      :placeholder="columns.region_id.title"
                      :id="form.region_id"
                      v-model="form.region_id"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-region>
                  </el-form-item>
                </div>

                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.district_id") }}
                  </span>
                  <el-form-item prop="district_id">
                    <select-district
                      :region_id="form.region_id"
                      :size="'medium'"
                      :placeholder="columns.district_id.title"
                      :id="form.district_id"
                      v-model="form.district_id"
                      :class="mode ? 'input__day' : 'input__night'"
                    >
                    </select-district>
                  </el-form-item>
                </div>
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2"> {{ $t('message.status') }} </span>
                  <el-form-item prop="status_id">
                    <select-status
                      :size="'medium'"
                      :placeholder="columns.status_id.title"
                      :table_name="'vacancies'"
                      :id="form.status_id"
                      :class="mode ? 'input__day' : 'input__night'"
                      v-model="form.status_id"
                    >
                    </select-status>
                  </el-form-item>
                </div>
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2"> {{$t('message.description')}} </span>
                  <el-input
                    type="textarea"
                    size="medium"
                    :placeholder="$t('message.description')"
                    v-model="form.description"
                    :class="mode ? 'input__day' : 'input__night'"
                  ></el-input>
                </div>
                
              </el-col>
              <el-col :span="24">
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.check_level") }}
                  </span>
                  <el-switch v-model="form.check_level"> </el-switch>
                </div>
              </el-col>
              <!-- end col -->
            </el-row>
            <div v-if="form.check_level">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="app-form__group mb-4">
                    <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                      {{ $t("message.question_direction_list") }}
                    </span>
                    <el-form-item
                        prop="title"
                        class="label_mini">
                          <select-question-direction  
                            :size="'medium'"
                            :class="mode ? 'input__day' : 'input__night'"
                            :multiple="true"
                            :id="form.question_direction_ids"
                            v-model="form.question_direction_ids" >
                          </select-question-direction>
                    </el-form-item>
                  </div>
              </el-col>
              <el-col :span="12">
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.question_count") }}
                  </span>
                  <el-form-item
                      prop="title"
                      class="question_count">
                      <crm-input
                        :class="mode ? 'input__day' : 'input__night'"
                        :inputValue="form.question_count"
                        :placeholder="$t('message.question_count')"
                        :size="'medium'"
                        :type="'number'"
                        v-model="form.question_count"
                      ></crm-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="app-form__group mb-4">
                  <span :class="mode ? 'text__day2' : 'text__night2'" class="input--label d-block mb-2">
                    {{ $t("message.min_point") }}
                  </span>
                  <el-form-item
                      prop="title"
                      class="min_point">
                      <crm-input
                        :class="mode ? 'input__day' : 'input__night'"
                        :inputValue="form.min_point"
                        :placeholder="$t('message.min_point')"
                        :size="'medium'"
                        :type="'number'"
                        v-model="form.min_point"
                      ></crm-input>
                  </el-form-item>
                </div>
              </el-col>
              </el-row>
            </div>
          </el-form>
        </div>
      </div>
      <!-- end app-modal__body -->
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import drawer from "@/utils/mixins/drawer";
import selectGender from "@/components/filters/inventory/select-gender";
import selectBrench from "@/components/filters/inventory/select-branch";
import selectCompany from "@/components/filters/inventory/select-company";
import selectDepartment from "@/components/filters/inventory/select-department";
import selectRequirement from "@/components/filters/inventory/select-requirement";
import selectPriority from "@/components/filters/inventory/select-priority";
import selectPosition from "@/components/filters/inventory/select-position";
import selectGraphic from "@/components/filters/inventory/select-graphic";
import selectEmploymentType from "@/components/filters/inventory/select-employmentType";
import selectLanguage from "@/components/filters/inventory/select-language";
import selectSkill from "@/components/filters/inventory/select-skill";
import selectCurrency from "@/components/filters/inventory/select-currency";
import selectRegion from "@/components/filters/inventory/select-region";
import selectDistrict from "@/components/filters/inventory/select-district";
import selectStatus from "@/components/filters/inventory/select-status";
import form from "@/utils/mixins/form";
import { i18n } from "@/utils/i18n";
export default {
  mixins: [drawer, form],
  name: "VacancyController",
  data() {
    return {};
  },
  components: {
    selectGender,
    selectBrench,
    selectDepartment,
    selectRequirement,
    selectPriority,
    selectPosition,
    selectGraphic,
    selectEmploymentType,
    selectLanguage,
    selectSkill,
    selectCurrency,
    selectRegion,
    selectDistrict,
    selectCompany,
    selectStatus,
  },
  mounted() {},
  computed: {
    ...mapGetters({
      rules: "vacancy/rules",
      model: "vacancy/model",
      columns: "vacancy/columns",
      mode:'MODE'
    }),
  },
  methods: {
    ...mapActions({
      save: "vacancy/store",
      empty: "vacancy/empty",
    }),
    submit(close = true) {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          this.save(this.form)
            .then((res) => {
              this.loadingButton = false;
              this.$alert(res);
              this.parent().listChanged();
              if (res.status == 201) {
                this.close();
                this.empty();
              }
            })
            .catch((err) => {
              this.loadingButton = false;
              this.$alert(err);
            });
        }
      });
    },
    afterLeave() {
      this.empty();
    },
  },
};
</script>
